import { useMutation } from '@tanstack/react-query';
import { POST, POST_OTP_CALL } from '../../../services';
import { openAlert } from '../../../components/alert/hooks';

export const useCallOtp = ({ onSuccessCallBack }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (payload) => {
      const response = await POST(POST_OTP_CALL(), payload);
      onSuccessCallBack && onSuccessCallBack(response);
      return response.result;
    },
    onSuccess: () => {
      openAlert({
        model: 'message',
        type: 'success',
        message: 'ส่งรหัส OTP สำเร็จ',
      });
    },
  });
  return { mutate, loading: isPending };
};
